import axios from 'axios';
import { getNonGwApiRoot } from '../../constants/ParamountReactConstants';

export function createLoadSheet(templateData: FormData) {
  return {
    type: 'CREATE_LOAD_SHEET',
    payload: axios.post(`${getNonGwApiRoot()}/distribution/load_sheets`, templateData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),
  };
}

export function clearLoadSheetsUploadError() {
  return {
    type: 'CLEAR_LOAD_SHEETS_ERROR',
  };
}
